import { FunctionComponent } from 'react';
import { Outlet } from 'react-router-dom';
import { PanelGroup } from '@cbridge-tools/resizable-panels';
import { MainPanel, SidePanelVariant, SidePanel, SinglePanel, usePersistedPanelLayout, panelLayoutSettingKey } from '@cbridge-modules/layout';
import { UserSettingsPage } from '@cbridge-packages/user-settings';
import { NodeListSubscriber } from '@cbridge-packages/node';
import { MarkupProfileListSubscriber } from '@cbridge-packages/markup-profile';
import { StreamsNodesSubNavigation } from '@cbridge-modules/nodes-sub-navigation';
import { StreamDetailsSidebar } from '../detailsView/StreamDetailsSidebar';
import { SettingsNavigation } from '../../_navigation/SettingsNavigation';

export const StreamsLayout: FunctionComponent = () => {
  const layoutProps = usePersistedPanelLayout(panelLayoutSettingKey(UserSettingsPage.ConfigSettingsStreams, 'page'));

  return (
    <>
      <NodeListSubscriber />
      <MarkupProfileListSubscriber />

      <PanelGroup direction={'horizontal'} {...layoutProps}>
        <SidePanel variant={SidePanelVariant.Left}>
          <SettingsNavigation />
          <SinglePanel>
            <StreamsNodesSubNavigation />
          </SinglePanel>
        </SidePanel>

        <MainPanel>
          <Outlet />
        </MainPanel>

        <StreamDetailsSidebar />
      </PanelGroup>
    </>
  );
};
